'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {renderComponentIfDefined} from '../../../../forms/utils';
import {EditFields, ViewFields} from '../fields';


export function FormFieldResponseView(props) {
  const field = props.field;
  return (
    <div
      className={classNames("FormFieldResponse", props.className, {
        FormFieldResponse_edit: props.isEditing,
        FormFieldResponse_view: !props.isEditing,
      })}
    >
      <h3 className="FormFieldResponse__heading">
        {field.title}
      </h3>
      {props.isEditing ? (
        <p className="FormFieldResponse__description">
          {field.description}
        </p>
      ) : null}
      {renderComponentIfDefined(props.isEditing ? EditFields : ViewFields, field.type, props)}
    </div>
  );
}

FormFieldResponseView.propTypes = {
  className: T.string,
  isEditing: T.bool,
  isSaving: T.bool.isRequired,
  field: T.object.isRequired,
  value: T.any.isRequired,
  validationMessages: T.arrayOf(T.string),

  onFieldChange: T.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/FormFieldResponse/FormFieldResponseView.js